import React, { useEffect, useState } from 'react';
import image1 from '../img/dir.png'
import image2 from '../img/dir2.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
const directors = [
  {
    name: "Arushi Singh",
    title: "Founder & Director",
    // description: "A Masters in English Literature and a C2 German Certificate from Goethe Institute, brings over a decade of experience in language training across multiple continents. As Executive Director, she ensures excellence in teaching.",
    description: `From the Desk of the Director

At Agni, we have always believed that language is not a subject to be studied but a living, breathing presence to be nurtured. It is like a companion — it grows stronger only when we feed it daily, care for it, and let it move with us in our lives. This philosophy was the seed from which Agni was born: to be a torchbearer of change in language learning, to revolutionize the way languages are acquired — not through rote learning, but through living, experiencing, and embracing them.
Agni is more than a school. It is a home for its students — created by them, for them, and belonging to them. Every learner here is given space to grow at their own pace, to feel safe, to feel challenged, and to feel inspired.
As Founder and Director, my role extends far beyond overseeing academics. I see myself as a curator of experiences, ensuring that our lessons move beyond the pages of books and into the heart of culture. At Agni, immersive learning is not about speaking a language endlessly — it is about diving into its nuances, dissecting the society it represents, and realizing that what seems foreign is, in many ways, familiar.
My own journey has been shaped by books, by words, and by languages that seemed to choose me as much as I chose them. From my earliest days, buried in novels, to my present role, guiding learners into new worlds of expression, the path revealed itself to me as naturally as language itself.
For our students, Agni is often the first step toward a life in Germany or Austria, but more importantly, it is a step into confidence, self-expression, and cultural belonging. My message to every learner is simple: live the language, embrace the culture, and let it transform you.
Agni is not just a school. It is a movement — a flame of learning that we carry together.
— Arushi Singh
Founder & Director`,
    image: image1, // replace with actual image source
  },
  // {
  //   name: "Rajveer Singh Chouhan",
  //   title: "Managing Director \n\n",
  //   description: "A Degree in Finance and C2 German Certificate from Goethe Institute. created our acclaimed B2 Integrated Exam Training Module. As Managing Director, he continuously enhances our curriculum for optimal learning",
  //   image: image2, // replace with actual image source
  // },
];

const MeetOurDirectors = () => {
  const [expandedDirector, setExpandedDirector] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const toggleReadMore = (index) => {
    setExpandedDirector(expandedDirector === index ? null : index);
  };
    
  return (
    <div id="about-us" className="bg-[#eefef8] p-8">
      <h2 className="text-black text-3xl font-bold mb-2 text-center">Meet Our Director</h2>
      <p className="text-gray-600 mb-8 text-center">Our Directors Leading the Way in Language Learning Excellence</p>
      
      <div className="flex flex-col md:flex-row justify-center items-center md:space-x-8">
        {directors.map((director, index) => (
          <div key={index} className=" lg:w-[40%] h-full rounded-lg  p-6 mb-8 md:mb-0 text-center w-72"   data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}>
            <div className="bg-[#fdf1e2] shadow-lg">
            <img
              src={director.image}
              alt={director.name}
              className="rounded-lg w-[70%] h-[30%] mx-auto mb-4 object-cover"
            />
            <h3 className="text-xl font-bold">{director.name}</h3>
            <p className="text-gray-500 mb-4 font-bold whitespace-pre-line">{director.title}</p>
            </div>
            
            {expandedDirector === index ? (
              <div className="text-gray-600 lg:mx-[10%] text-contain font-bold text-sm">
                <p className="mb-4 text-left text-lg font-bold">From the Desk of the Director</p>
                <div className="space-y-4 text-left">
                  <p>At Agni, we have always believed that language is not a subject to be studied but a living, breathing presence to be nurtured. It is like a companion — it grows stronger only when we feed it daily, care for it, and let it move with us in our lives. This philosophy was the seed from which Agni was born: to be a torchbearer of change in language learning, to revolutionize the way languages are acquired — not through rote learning, but through living, experiencing, and embracing them.</p>
                  
                  <p>Agni is more than a school. It is a home for its students — created by them, for them, and belonging to them. Every learner here is given space to grow at their own pace, to feel safe, to feel challenged, and to feel inspired.</p>
                  
                  <p>As Founder and Director, my role extends far beyond overseeing academics. I see myself as a curator of experiences, ensuring that our lessons move beyond the pages of books and into the heart of culture. At Agni, immersive learning is not about speaking a language endlessly — it is about diving into its nuances, dissecting the society it represents, and realizing that what seems foreign is, in many ways, familiar.</p>
                  
                  <p>My own journey has been shaped by books, by words, and by languages that seemed to choose me as much as I chose them. From my earliest days, buried in novels, to my present role, guiding learners into new worlds of expression, the path revealed itself to me as naturally as language itself.</p>
                  
                  <p>For our students, Agni is often the first step toward a life in Germany or Austria, but more importantly, it is a step into confidence, self-expression, and cultural belonging. My message to every learner is simple: live the language, embrace the culture, and let it transform you.</p>
                  
                  <p>Agni is not just a school. It is a movement — a flame of learning that we carry together.</p>
                  
                  <p className="text-right mt-4 whitespace-pre-line">— Arushi Singh{'\n'}Founder & Director</p>
                </div>
                <button
                  onClick={() => toggleReadMore(index)}
                  className="text-orange-500 hover:text-orange-600 font-semibold mt-4 transition-colors duration-200"
                >
                  Read Less
                </button>
              </div>
            ) : (
              <div className="text-gray-600 lg:mx-[10%] text-contain font-bold text-sm">
                <p className="mb-2 text-left text-lg font-bold">From the Desk of the Director</p>
                <p className="text-left mb-4">At Agni, we have always believed that language is not a subject to be studied but a living, breathing presence to be nurtured. It is like a companion — it grows stronger only when we feed it daily, care for it, and let it move with us in our lives. This philosophy was the seed from which Agni was born: to be a torchbearer of change in language learning, to revolutionize the way languages are acquired — not through rote learning, but through living, experiencing, and embracing them.</p>
                <button
                  onClick={() => toggleReadMore(index)}
                  className="text-orange-500 hover:text-orange-600 font-semibold transition-colors duration-200"
                >
                  Read More
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetOurDirectors;
